import { render, staticRenderFns } from "./EmailView.vue?vue&type=template&id=a7cd72e6&scoped=true"
var script = {}
import style0 from "./EmailView.vue?vue&type=style&index=0&id=a7cd72e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cd72e6",
  null
  
)

export default component.exports